import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

import { Title } from '../types';

interface SvgProps extends React.SVGProps<SVGSVGElement>, Title {
	svg: React.FunctionComponent<React.SVGProps<SVGSVGElement> & Title>;
	color: string;
}

const Svg: React.FC<SvgProps> = props => {
	const { svg: Svg, color, className, ...rest } = props;

	const classes = useStyles(props);

	return <Svg {...rest} className={clsx(classes.svg, className)} />;
}

export default Svg;

const useStyles = makeStyles({
	svg: {
		'& .a': {
			fill: (props: SvgProps) => props.color
		}
	}
});